export enum TipoEstacaoMeteorologicaEnum {
    LOCAL = 'local',
    REMOTA = 'remota',
}
